const handleSubmitValidation = (input, sessionId) => {
  const errors = [];

  if (!input?.trim()) {
    errors.push('Message cannot be empty');
  }

  if (!sessionId) {
    errors.push('No active session');
  }

  return {
    isValid: errors.length === 0,
    errors,
    cleanInput: input?.trim() || '',
  };
};

const shouldPreventSubmit = (input, isLoading) => !input?.trim() || isLoading;

export { handleSubmitValidation, shouldPreventSubmit };
